export default __webpack_public_path__ + "static/media/logo-bouddha2.d4098c36.svg";